import axios from 'axios';
import Cookies from 'universal-cookie';

const api = axios.create();

api.interceptors.request.use(config => {
    const cookies = new Cookies();
    const token = cookies.get('tkn');
    if (token) config.headers['auth-token'] = token;
    return config;
});

api.interceptors.response.use(
    res => res,
    err => {
        const message = err?.response?.data?.error || 'Unexpected error';
        return Promise.reject(new Error(message));
    }
);

export default api;
